import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Editorial preloader with masked reveal
const Preloader = ({ onDone }) => {
  const [pct, setPct] = useState(0);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    let raf;
    let done = false;
    let start = performance.now();
    const duration = 1400;
    const finish = () => {
      if (done) return;
      done = true;
      setPct(100);
      setGone(true);
      onDone && onDone();
    };
    const tick = (t) => {
      const p = Math.min(1, (t - start) / duration);
      setPct(Math.floor(p * 100));
      if (p < 1) raf = requestAnimationFrame(tick);
      else setTimeout(finish, 250);
    };
    raf = requestAnimationFrame(tick);
    // Hard fallback: guarantee the preloader clears even if RAF is throttled
    const fallback = setTimeout(finish, 2600);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(fallback);
    };
  }, [onDone]);

  return (
    <AnimatePresence>
      {!gone && (
        <motion.div
          initial={{ y: 0 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 1.0, ease: [0.85, 0, 0.15, 1] }}
          className="fixed inset-0 z-[200] bg-[var(--ink)] flex flex-col justify-between px-6 md:px-10 py-8"
          data-testid="preloader"
        >
          <div className="flex justify-between font-mono text-[10px] tracking-[0.28em] uppercase text-[var(--bone-dim)]">
            <span>Preeti Basu · Portfolio</span>
            <span>MMXXVI</span>
          </div>

          <div className="flex flex-col items-start gap-6">
            <div className="font-serif text-6xl md:text-9xl leading-none text-[var(--bone)]">
              <span className="italic">Loading</span>
              <span className="text-[var(--copper)]">.</span>
            </div>
            <div className="w-full max-w-md h-px bg-[var(--bone)]/10 overflow-hidden">
              <motion.div
                animate={{ width: `${pct}%` }}
                transition={{ ease: "linear" }}
                className="h-full bg-[var(--copper)]"
              />
            </div>
          </div>

          <div className="flex justify-between font-mono text-[10px] tracking-[0.28em] uppercase text-[var(--bone-dim)]">
            <span className="text-[var(--copper)]">{pct.toString().padStart(3, "0")} / 100</span>
            <span>Payments · Product · AI</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Preloader;
